import React from 'react';
import { Error } from './styles';

export default ({ message }) => <Error>{message}</Error>;
